import { render } from "./reservationsIndex.vue?vue&type=template&id=6bb477f2&scoped=true"
import script from "./reservationsIndex.vue?vue&type=script&lang=js"
export * from "./reservationsIndex.vue?vue&type=script&lang=js"

import "./reservationsIndex.vue?vue&type=style&index=0&id=6bb477f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6bb477f2"

export default script